import { registerFont } from 'utils/fontRegistry';

// FontRegistry allows fine-grained control over per-typeface props
// registerFont defaults to display: 'swap' for all typefaces
// Tip: Add `preload: true` to typefaces as required

// Used inside _document.tsx for Pages Router
export const registerPagesRouterFonts = () => {
  registerFont({
    name: 'Saol Text',
    src: [
      { path: '/fonts/SaolText-Regular.woff2', weight: '400' },
      { path: '/fonts/SaolText-Semibold.woff2', weight: '600', preload: true },
      { path: '/fonts/SaolText-Bold.woff2', weight: '700' },
    ],
    variable: '--saol-text',
  });

  registerFont({
    name: 'Graphik Condensed',
    src: [
      { path: '/fonts/GraphikCondensed-Light-Web.woff2', weight: '300', preload: true },
      { path: '/fonts/GraphikCondensed-Regular-Web.woff2', weight: '400' },
      { path: '/fonts/GraphikCondensed-Medium-Web.woff2', weight: '500' },
      { path: '/fonts/GraphikCondensed-Semibold-Web.woff2', weight: '600', preload: true },
      { path: '/fonts/GraphikCondensed-Bold-Web.woff2', weight: '700' },
    ],
    variable: '--graphik-cond',
  });

  registerFont({
    name: 'Graphik Compact',
    src: [
      { path: '/fonts/GraphikCompact-Medium-Web.woff2', weight: '500' },
      { path: '/fonts/GraphikCompact-Semibold-Web.woff2', weight: '700' },
      { path: '/fonts/GraphikCompact-Regular-Web.woff2', weight: '400' },
    ],
    variable: '--graphik-compact',
  });

  registerFont({
    name: 'Graphik',
    src: [
      { path: '/fonts/Graphik-Regular.woff2', weight: '400' },
      { path: '/fonts/Graphik-Medium.woff2', weight: '500' },
      { path: '/fonts/Graphik-Semibold.woff2', weight: '600' },
    ],
    variable: '--graphik',
  });

  registerFont({
    name: 'Inria Serif',
    src: [
      { path: '/fonts/InriaSerif-Regular.woff2', weight: '400' },
      { path: '/fonts/InriaSerif-Bold.woff2', weight: '700' },
    ],
    variable: '--inria-serif',
  });
};

// Used inside App Router layouts
export const registerAppRouterFonts = () => {
  registerFont({
    name: 'Graphik Compact',
    src: [
      { path: '/fonts/GraphikCompact-Regular-Web.woff2', weight: '400' },
      { path: '/fonts/GraphikCompact-Medium-Web.woff2', weight: '500' },
      { path: '/fonts/GraphikCompact-Semibold-Web.woff2', weight: '600', preload: true },
    ],
    variable: '--font-graphik-compact',
  });

  registerFont({
    name: 'Graphik',
    src: [
      { path: '/fonts/Graphik-Regular.woff2', weight: '400' },
      { path: '/fonts/Graphik-Medium.woff2', weight: '500' },
      { path: '/fonts/Graphik-Semibold.woff2', weight: '600' },
    ],
    variable: '--font-graphik',
  });

  registerFont({
    name: 'Inria Serif',
    src: [
      { path: '/fonts/InriaSerif-Regular.woff2', weight: '400' },
      { path: '/fonts/InriaSerif-Bold.woff2', weight: '700', preload: true },
    ],
    variable: '--font-inria-serif',
  });
};
